const SEEN_KEY = 'stockroom_deal_seen';
const SEEN_CAP = 500;
const EXCLUDE_QUERY_CAP = 400;

function readSeenList() {
  try {
    const raw = sessionStorage.getItem(SEEN_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
  } catch {
    return [];
  }
}

function writeSeenList(ids) {
  try {
    sessionStorage.setItem(SEEN_KEY, JSON.stringify(ids.slice(-SEEN_CAP)));
  } catch (_) {}
}

/** Hydrate a Set with product IDs already shown in Deal Feed this browser session. */
export function loadDealFeedSeen() {
  return new Set(readSeenList());
}

/** Most recent seen IDs for API exclude (URL length safe). */
export function dealFeedExcludeIds(seenSet) {
  const list = seenSet instanceof Set ? [...seenSet] : readSeenList();
  return list.slice(-EXCLUDE_QUERY_CAP);
}

/** Persist newly shown product IDs into session memory (FIFO cap). */
export function rememberDealFeedSeen(ids) {
  if (!ids || ids.length === 0) return;
  const existing = readSeenList();
  const seen = new Set(existing);
  const next = [...existing];
  ids.forEach((id) => {
    const key = String(id || '');
    if (!key || seen.has(key)) return;
    seen.add(key);
    next.push(key);
  });
  writeSeenList(next);
}

/** Drop oldest half when starting a starved open (never mid-scroll). */
export function shrinkDealFeedSeen() {
  const existing = readSeenList();
  if (existing.length === 0) return [];
  const kept = existing.slice(Math.floor(existing.length / 2));
  writeSeenList(kept);
  return kept;
}

/** New seed per Deal Feed open so ranking jitter reshuffles. */
export function createFeedSeed() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (_) {}
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
